// src/store/apis/bulkReconciliation.js
//
// Per-feature API client for /api/bulk-reconciliation/*.
// Uses the shared $axios instance (auth header attached by the interceptor in
// src/store/apis/index.js). Each function unwraps the JSON `data` envelope
// the way the rest of the app does, so callers receive plain objects.

import { $axios } from './index';

const BASE = 'bulk-reconciliation';

export async function listBatches(params = {}) {
  const res = await $axios.get(BASE, { params });
  return res.data;
}

export async function createBatch({ start_date, end_date }) {
  const res = await $axios.post(BASE, { start_date, end_date });
  return res.data?.data ?? res.data;
}

export async function getBatch(uuid) {
  const res = await $axios.get(`${BASE}/${uuid}`);
  return res.data?.data ?? res.data;
}

export async function uploadStatement(uuid, bank, file) {
  const formData = new FormData();
  formData.append('bank', bank);
  formData.append('file', file);
  const res = await $axios.post(`${BASE}/${uuid}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000,
  });
  return res.data?.data ?? res.data;
}

export async function runMatching(uuid) {
  const res = await $axios.post(`${BASE}/${uuid}/match`);
  return res.data;
}

export async function getRecords(uuid, params = {}) {
  const res = await $axios.get(`${BASE}/${uuid}/records`, { params });
  return res.data;
}

export async function linkBill(uuid, recordId, billId) {
  const res = await $axios.post(`${BASE}/${uuid}/link/${recordId}`, { bill_id: billId });
  return res.data?.data ?? res.data;
}

export async function closeBatch(uuid) {
  const res = await $axios.post(`${BASE}/${uuid}/close`);
  return res.data?.data ?? res.data;
}
